import type { TOption } from '@vlabs/uikit/types';

import type { Filter, Column } from '@vlabs/api/luna-api/model';

import { FILTER_FIELDS } from './filterFieldsConfig';
import { filterFunctionOptions } from '../../constants';

type FilterOptions = TOption & { isDisabled: boolean };

const getSelectedColumns = (filters: Filter[] = []): Column[] => {
  return filters
    .map((filter) => filter.column)
    .filter(Boolean);
};

export const getFilterColumnOptions = ({
  filters = [],
  index,
}: { filters: Filter[]; index: number }): FilterOptions[] => {
  // Текущий фильтр должен оставаться редактируемым, но все остальные выбранные фильтры должны блокировать конфликтующие поля
  const selectedColumns = getSelectedColumns(filters.filter((_, filterIndex) => filterIndex !== index));
  return Object.entries(FILTER_FIELDS).map(([value, config]) => {
    const hasConflict: boolean = config.conflictsWith?.some((field: Column) => selectedColumns.includes(field));

    return {
      label: config.label,
      value,
      isDisabled: hasConflict,
    };
  });
};

export const getOperatorOptions = (columnValue: Column): TOption[] => {
  const availableFunctions: string[] | undefined = FILTER_FIELDS[
    columnValue as keyof typeof FILTER_FIELDS
  ]?.availableFunctions;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return filterFunctionOptions.raw.filter((option: TOption): boolean => availableFunctions?.includes(option.value));
};

export const getFilterValueConfig = (fieldName: Column): Record<string, any> => FILTER_FIELDS[
  fieldName as keyof typeof FILTER_FIELDS
];
